import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  uploadedVideoList: [],
};

export const UploadVideoReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_UPLOADED_VIDEO_LIST:
      return { ...state, uploadedVideoList: payload };

    case ActionTypes.REMOVE_UPLOADED_VIDEO:
      const newData = state.uploadedVideoList.splice(
        payload.selectedFileIndex,
        1
      );
      return { ...state };

    case ActionTypes.RENAME_UPLOADED_VIDEO:
      let updatingState = JSON.parse(JSON.stringify(state));
      let videoList = [...updatingState.uploadedVideoList];
      const videoIndex = videoList.findIndex((data) => data.id === payload.id);
      videoList[videoIndex].fileName = payload.videoName + ".mp4";
      return { ...updatingState };

    case ActionTypes.RENAME_UPLOADED_VIDEO_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case ActionTypes.RESET_UPLOAD_VIDEO_INITIAL_STATE:
      return initialState;

    default:
      return state;
  }
};
